import { useEffect, useState } from "react";
import axios from "../../../axios";
import { Link, useNavigate } from "react-router-dom";
import handleApiError from "../../../utils/handleApiError";
import SuccessModal from "../../components/SuccessModal";
import ErrorModal from "../../components/ErrorModal";
import formatCurrency from "../../../utils/formatCurrency";
import { STORAGE_URL } from "../../../constants";

export default function ProductListPage() {
    const [products, setProducts] = useState([]);

    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const fetchProducts = async () => {
        setLoading(true);
        try {
            const res = await axios.get("/admin/products");
            console.log(res.data);
            setProducts(res.data);
        } catch (err) {
            setError(handleApiError(err));
        }
        finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Yakin ingin mengarsipkan produk ini?")) return;

        try {
            await axios.delete(`/admin/products/${id}`);
            fetchProducts(); // refresh data
        } catch (err) {
            alert("Gagal mengarsipkan produk");
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    return (
        <div className="mt-20 card">
            <div className="d-flex justify-content-between align-items-center mb-4 card-header">
                <h2>Daftar Produk</h2>
                <Link to="/admin/products/create" className="btn btn-main">
                    + Tambah Produk
                </Link>
            </div>
            <ErrorModal error={error} onClose={() => setError("")} />
            <SuccessModal
                message={success}
                onClose={() => {
                    setSuccess("");
                    navigate("/admin/products");
                }}
            />
            {products.length === 0 ? (
                <div className="table-responsive card-body">
                <p>Tidak ada produk.</p>
                </div>
            ) : (
                <div className="table-responsive card-body">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Foto</th>
                                <th>Nama</th>
                                <th>Kategori</th>
                                <th>Harga</th>
                                <th>Status</th>
                                <th style={{ width: "150px" }}>Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.map((p) => (
                                <tr key={p.id}>
                                    <td>
                                        {p.photos && p.photos.length > 0 ? (
                                            <img
                                                src={`${STORAGE_URL}${p.photos[0].file_path}`}
                                                alt={p.name}
                                                width="60"
                                                height="60"
                                                style={{ objectFit: "cover" }}
                                            />
                                        ) : (
                                            <span>Tidak ada foto</span>
                                        )}
                                    </td>
                                    <td>{p.name}</td>
                                    <td>
                                        {p.category?.name ?? "-"} / {p.subcategory?.name ?? "-"}
                                    </td>
                                    <td><small>From</small> <br /> {formatCurrency(parseInt(p.category_price)+parseInt(p.subcategory_price))}</td>
                                    <td>{p.status}</td>
                                    <td>
                                        <Link to={`/admin/products/${p.id}/edit`} className="btn btn-sm btn-warning">
                                            Edit
                                        </Link>
                                        {
                                            p.status !== "archived" ? (
                                                <button
                                                    onClick={() => handleDelete(p.id)}
                                                    className="btn btn-sm btn-danger ms-2"
                                                >
                                                    Arsipkan
                                                </button>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
